import { useEffect, useState } from 'react';

export enum Systems {
  Unknown = 'unknown',
  Windons = 'windows',
  Macintosh = 'macintosh',
  Linux = 'linux',
  Android = 'android',
  IOS = 'ios',
}

export function useGetSystemInformation() {
  const [system, setSystem] = useState(Systems.Unknown);

  useEffect(() => {
    if (navigator.userAgent.indexOf('Win') != -1) setSystem(Systems.Windons);
    if (navigator.userAgent.indexOf('Mac') != -1) setSystem(Systems.Macintosh);
    if (navigator.userAgent.indexOf('Linux') != -1) setSystem(Systems.Linux);
    if (navigator.userAgent.indexOf('Android') != -1) setSystem(Systems.Android);
    if (navigator.userAgent.indexOf('like Mac') != -1) setSystem(Systems.IOS);
  }, []);

  return { system, isMobileOS: Boolean(system === Systems.Android || system === Systems.IOS) };
}
